import React, {useState} from 'react';
import {Button, Checkbox, DatePicker, Form, Input} from 'antd'
import {MaskedInput} from 'antd-mask-input';

import {POLICY} from '../../config/routes';
import {IFormActivate} from '../../shared/forms/forms';
import {activateRegex, certRegex, phoneRegex} from '../../shared/helpers/regex';

interface FormProps {
    onComplete: (values:IFormActivate) => void
}

const ActivateForm = ({onComplete}: FormProps) => {

    const [form] = Form.useForm()
    const [termsAccepted, setTermsAccepter] = useState<boolean>(true)
    const [adAccepted, setadAccepter] = useState<boolean>(true)

    const onFinish = (values:IFormActivate) => {
        onComplete({
            ...values,
            termsAccepted,
            adAccepted,
        })
    }

    return (
        <Form form={form} layout={'vertical'} size={'large'} validateTrigger={'onSubmit'} onFinish={onFinish}>

            <Form.Item name={'Certificate_Number'} label={'Номер сертификата'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: certRegex, message: 'Не соответствует формату номера сертификата'},
                {pattern: activateRegex, message: 'Данный сертификат не подлежит активации'}
            ]}>
                <Input placeholder={'24WTM0000000000'}/>
            </Form.Item>

            <Form.Item name={'Certificate_Date'} label={'Дата выдачи сертификата'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <DatePicker format={'DD.MM.YYYY'}/>
            </Form.Item>

            <Form.Item name={'FIO'} label={'ФИО'} rules={[{required: true, message: 'Заполните, пожалуйста'}]}>
                <Input placeholder={'Иванов Иван Иванович'}/>
            </Form.Item>
            <Form.Item name={'Phone'} label={'Номер телефона'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {pattern: phoneRegex, message: 'Не соответствует формату номера телефона'}
            ]}>
                <MaskedInput mask={'+7 (000) 000-00-00'} placeholder={'+7 (999) 888-77-66'} size={'large'}/>
            </Form.Item>
            <Form.Item name={'Email'} label={'Email'} rules={[
                {required: true, message: 'Заполните, пожалуйста'},
                {type: 'email', message: 'Не соответствует формату email'},
            ]}>
                <Input placeholder={'name@example.com'}/>
            </Form.Item>

            <Form.Item>
                <Checkbox checked={termsAccepted} onChange={() => setTermsAccepter(!termsAccepted)}>Я ознакомился и соглашаюсь с <a href={POLICY} rel={'noreferrer'} target={'_blank'}>политикой
                    конфиденциальности</a> и <a href={POLICY} rel={'noreferrer'} target={'_blank'}>правилами обработки персональных данных</a></Checkbox>
            </Form.Item>
            <Form.Item>
                <Checkbox checked={adAccepted} onChange={() => setadAccepter(!adAccepted)}>Я соглашаюсь на получение информационных и рекламных материалов</Checkbox>
            </Form.Item>
            <Form.Item>
                <Button type={'primary'} htmlType={'submit'} disabled={!termsAccepted}>Активировать сертификат</Button>
            </Form.Item>
        </Form>
    )
}

export default ActivateForm